// imports react
import React, { useEffect, useReducer, useState } from "react";

//imports libraries
import { toast } from "sonner";
import axios from "axios";
import { useNavigate } from "react-router-dom";

//imports components
import { Menu } from "../../components/Menu";
import { AdminUser } from "../../components/AdminUser";

import { urlAPI_Current } from "../../config";
import { SwitchMode } from "../../components/SwitchMode";
import Swal from "sweetalert2";
import { verifyAuthToken } from "../../verifyAuthToken";

export function AdminTemplate() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBlock, setIsLoadingBlock] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigateTo = useNavigate();

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  const backgroundColor = darkMode ? "#1e1e1e" : "#FFFFFF";
  const colorInput = darkMode ? "#26272F" : "#F9F9F9";

  async function getQuestionsAnswered(userId) {
    try {
      const response = await axios.post(
        `${urlAPI_Current}/getQuestionsAnswered`,
        {
          selectedUserId: userId,
        }
      );
      if (response.data.success == true) {
        const responseQuestions = response.data.lastAnswered;
        if (responseQuestions === 12) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.log("Erro ao buscar respondidas");
      return false;
    }
  }

  async function getAllUsers() {
    try {
      const responseProfile = await axios.post(`${urlAPI_Current}/getAllUsers`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
     } );
  
      if (responseProfile.data.success) {
        const users = responseProfile.data.users;
        if (users) {
          setUsers(users); 
          console.log(users);
        }
      } else {
        console.log("Erro ao buscar usuarios");
      }
    } catch (error) {
      console.log("Erro ao buscar usuarios");
    }
  }

  async function sendEmail(userId) {
    setIsLoading(true);
    const questionaryisAnswered = await getQuestionsAnswered(userId);
    if (questionaryisAnswered) {
      try {
        const responseEmail = await axios.post(
          `${urlAPI_Current}/sendEmailQuestionary`,
          {
            selectedUserId: userId,
          }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
         }
        );
        if (responseEmail.data.success == true) {
          toast.success("Email enviado com sucesso!");
          getAllUsers();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error("O usuário não respondeu o questionario");
      setIsLoading(false);
    }
  }

  async function blockAccess(userId) {
    setIsLoadingBlock(true);
    const questionaryisAnswered = await getQuestionsAnswered(userId);
    if (questionaryisAnswered) {
      try {
        const responseEmail = await axios.post(
          `${urlAPI_Current}/updateAccess`,
          {
            selectedUserId: userId,
          }
        );
        if (responseEmail.data.success == true) {
          toast.success("Acesso bloquado com sucesso!");
          getAllUsers();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoadingBlock(false);
      }
    } else {
      toast.error("O usuário não respondeu o questionario");
      setIsLoadingBlock(false);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
        try {
            const responseEmail = await axios.post(
                `${urlAPI_Current}/getProfile`, {} , {
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                  }
               }
            );

            if (responseEmail.data.user.codTipoUsuario == 2) {
              getAllUsers();
            } else {
                toast.error("Você não tem acesso a essa página");
                navigateTo("/login");
            }
        } catch (error) {
            console.error("Erro ao buscar perfil:", error);
        }
    };

    fetchData();

    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredUsers = users.filter(
    (user) =>
      user.nome.toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );

  useEffect(() => {
    verifyAuthToken(navigateTo);
  }, []);

  return (
    <div>
      <Menu darkMode={darkMode} adminUser={true} adminPageActually="usuarios" />
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
        style={{
          marginTop: "136px",
        }}
        data-bs-theme={darkMode ? "dark" : "light"}
      >
         <div id="kt_content_container" className="container-xxl"
         style={{
          maxWidth: '1600px',   
          width: '100%',        
        }}
        >
          <div
            className="card"
            style={{
              backgroundColor,
            }}
          >
            <div className="card-header border-0 pt-6">
            <div className="card-title">
              <div className="d-flex align-items-center justify-content-between position-relative my-1">
              <div className="d-flex flex-column align-items-start">
                  <th className="mb-4">Usuários do Sistema: </th>
                  
                  <div className="d-flex align-items-center position-relative">
                    <i className="ki-outline ki-magnifier fs-3 position-absolute ms-5"></i>
                    
                    <input
                      type="text"
                      data-kt-user-table-filter="search"
                      className="form-control form-control-solid w-250px ps-13"
                      style={{
                        backgroundColor: colorInput,
                      }}
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Filtre por nome ou email"
                    />
                  </div>
                </div>

                </div>
              </div>
              <div className="card-toolbar">
                <div
                  className="d-flex justify-content-between align-items-center h-10"
                  data-kt-user-table-toolbar="base"
                >
                  <div className="d-flex align-items-center mb-0">
                    <div
                      className="d-flex justify-content-end"
                      data-kt-user-table-toolbar="base"
                    >
                      

                    </div>
                  </div>

                </div>

                <div
                  className="d-flex justify-content-end align-items-center d-none"
                  data-kt-user-table-toolbar="selected"
                >
                  <div className="fw-bold me-5">
                    <span
                      className="me-2"
                      data-kt-user-table-select="selected_count"
                    ></span>
                    Selected
                  </div>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-kt-user-table-select="delete_selected"
                  >
                    Delete Selected
                  </button>
                </div>

                <div
                  className="modal fade"
                  id="kt_modal_export_users"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered mw-650px">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h2 className="fw-bold">Export Users</h2>

                        <div
                          className="btn btn-icon btn-sm btn-active-icon-primary"
                          data-kt-users-modal-action="close"
                        >
                          <i className="ki-outline ki-cross fs-1"></i>
                        </div>
                      </div>

                      <div className="modal-body scroll-y mx-5 mx-xl-15 my-7">
                        <form
                          id="kt_modal_export_users_form"
                          className="form"
                          action="#"
                        >
                          <div className="fv-row mb-10">
                            <label className="fs-6 fw-semibold form-label mb-2">
                              Select Roles:
                            </label>

                            <select
                              name="role"
                              data-control="select2"
                              data-placeholder="Select a role"
                              data-hide-search="true"
                              className="form-select form-select-solid fw-bold"
                            >
                              <option></option>
                              <option defaultValue="Administrator">
                                Administrator
                              </option>
                              <option defaultValue="Analyst">Analyst</option>
                              <option defaultValue="Developer">
                                Developer
                              </option>
                              <option defaultValue="Support">Support</option>
                              <option defaultValue="Trial">Trial</option>
                            </select>
                          </div>

                          <div className="fv-row mb-10">
                            <label className="required fs-6 fw-semibold form-label mb-2">
                              Select Export Format:
                            </label>

                            <select
                              name="format"
                              data-control="select2"
                              data-placeholder="Select a format"
                              data-hide-search="true"
                              className="form-select form-select-solid fw-bold"
                            >
                              <option></option>
                              <option defaultValue="excel">Excel</option>
                              <option defaultValue="pdf">PDF</option>
                              <option defaultValue="cvs">CVS</option>
                              <option defaultValue="zip">ZIP</option>
                            </select>
                          </div>

                          <div className="text-center">
                            <button
                              type="reset"
                              className="btn btn-light me-3"
                              data-kt-users-modal-action="cancel"
                            >
                              Discard
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              data-kt-users-modal-action="submit"
                            >
                              <span className="indicator-label">Submit</span>
                              <span className="indicator-progress">
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                              </span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="modal fade"
                  id="kt_modal_add_user"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered mw-650px">
                    <div className="modal-content">
                      <div
                        className="modal-header"
                        id="kt_modal_add_user_header"
                      >
                        <h2 className="fw-bold">Add User</h2>

                        <div
                          className="btn btn-icon btn-sm btn-active-icon-primary"
                          data-kt-users-modal-action="close"
                        >
                          <i className="ki-outline ki-cross fs-1"></i>
                        </div>
                      </div>

                      <div className="modal-body px-5 my-7">
                        <form
                          id="kt_modal_add_user_form"
                          className="form"
                          action="#"
                        >
                          <div
                            className="d-flex flex-column scroll-y px-5 px-lg-10"
                            id="kt_modal_add_user_scroll"
                            data-kt-scroll="true"
                            data-kt-scroll-activate="true"
                            data-kt-scroll-max-height="auto"
                            data-kt-scroll-dependencies="#kt_modal_add_user_header"
                            data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                            data-kt-scroll-offset="300px"
                          >
                            <div className="fv-row mb-7">
                              <label className="d-block fw-semibold fs-6 mb-5">
                                Avatar
                              </label>

                              <div
                                className="image-input image-input-outline image-input-placeholder"
                                data-kt-image-input="true"
                              >
                                <div className="image-input-wrapper w-125px h-125px"></div>

                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                  data-kt-image-input-action="change"
                                  data-bs-toggle="tooltip"
                                  title="Change avatar"
                                >
                                  <i className="ki-outline ki-pencil fs-7"></i>

                                  <input
                                    type="file"
                                    name="avatar"
                                    accept=".png, .jpg, .jpeg"
                                  />
                                  <input type="hidden" name="avatar_remove" />
                                </label>

                                <span
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                  data-kt-image-input-action="cancel"
                                  data-bs-toggle="tooltip"
                                  title="Cancel avatar"
                                >
                                  <i className="ki-outline ki-cross fs-2"></i>
                                </span>

                                <span
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                  data-kt-image-input-action="remove"
                                  data-bs-toggle="tooltip"
                                  title="Remove avatar"
                                >
                                  <i className="ki-outline ki-cross fs-2"></i>
                                </span>
                              </div>

                              <div className="form-text">
                                Allowed file types: png, jpg, jpeg.
                              </div>
                            </div>

                            <div className="fv-row mb-7">
                              <label className="required fw-semibold fs-6 mb-2">
                                Full Name
                              </label>

                              <input
                                type="text"
                                name="user_name"
                                className="form-control form-control-solid mb-3 mb-lg-0"
                                placeholder="Full name"
                                defaultValue="Emma Smith"
                              />
                            </div>

                            <div className="fv-row mb-7">
                              <label className="required fw-semibold fs-6 mb-2">
                                Email
                              </label>

                              <input
                                type="email"
                                name="user_email"
                                className="form-control form-control-solid mb-3 mb-lg-0"
                                placeholder="example@domain.com"
                                defaultValue="smith@kpmg.com"
                              />
                            </div>

                            <div className="mb-5">
                              <label className="required fw-semibold fs-6 mb-5">
                                Role
                              </label>
                              <div className="d-flex fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    defaultValue="0"
                                    id="kt_modal_update_role_option_0"
                                  />
                                  <label className="form-check-label">
                                    <div className="fw-bold text-gray-800">
                                      Administrator
                                    </div>
                                    <div className="text-gray-600">
                                      Best for business owners and company
                                      administrators
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div className="separator separator-dashed my-5"></div>
                              <div className="d-flex fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    defaultValue="1"
                                    id="kt_modal_update_role_option_1"
                                  />
                                  <label className="form-check-label">
                                    <div className="fw-bold text-gray-800">
                                      Developer
                                    </div>
                                    <div className="text-gray-600">
                                      Best for developers or people primarily
                                      using the API
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div className="separator separator-dashed my-5"></div>
                              <div className="d-flex fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    defaultValue="2"
                                    id="kt_modal_update_role_option_2"
                                  />
                                  <label className="form-check-label">
                                    <div className="fw-bold text-gray-800">
                                      Analyst
                                    </div>
                                    <div className="text-gray-600">
                                      Best for people who need full access to
                                      analytics data, but don't need to update
                                      business settings
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div className="separator separator-dashed my-5"></div>
                              <div className="d-flex fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    defaultValue="3"
                                    id="kt_modal_update_role_option_3"
                                  />
                                  <label className="form-check-label">
                                    <div className="fw-bold text-gray-800">
                                      Support
                                    </div>
                                    <div className="text-gray-600">
                                      Best for employees who regularly refund
                                      payments and respond to disputes
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div className="separator separator-dashed my-5"></div>
                              <div className="d-flex fv-row">
                                <div className="form-check form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    defaultValue="4"
                                    id="kt_modal_update_role_option_4"
                                  />
                                  <label className="form-check-label">
                                    <div className="fw-bold text-gray-800">
                                      Trial
                                    </div>
                                    <div className="text-gray-600">
                                      Best for people who need to preview
                                      content data, but don't need to make any
                                      updates
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-center pt-10">
                            <button
                              type="reset"
                              className="btn btn-light me-3"
                              data-kt-users-modal-action="cancel"
                            >
                              Discard
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              data-kt-users-modal-action="submit"
                            >
                              <span className="indicator-label">Submit</span>
                              <span className="indicator-progress">
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                              </span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body py-4 bg" style={{ overflowX: "auto" }}>
              <table
                className="table align-middle table-row-dashed fs-6 gy-5"
                id="kt_table_users"
                style={{ minWidth: "100%" }}
              >
                <thead>
                  <tr className="text-start fs-7 text-uppercase">
                    <th className="w-10px pe-2">
                      <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          data-kt-check="true"
                          data-kt-check-target="#kt_table_users .form-check-input"
                          defaultValue="1"
                        />
                      </div>
                    </th>
                    <th className="min-w-125px">Perfil do Usuário</th>
                    <th className="min-w-125px">Nascimento</th>
                    <th className="min-w-20px">Idade</th>
                    <th className="min-w-100px">Celular</th>
                    <th className="min-w-100px">Plano</th>
                    <th className="min-w-100px">Relatorio</th>
                    <th className="min-w-125px">Tokens</th>
                    <th className="text-end min-w-100px">Configurações</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 fw-semibold">
                {filteredUsers.length === 0 ? (
                  <tr className="odd">
                    <td valign="top" colSpan="7" className="dataTables_empty">
                      Nenhum usuario encontrado
                    </td>
                  </tr>
                ) : (
                  filteredUsers.map((user) => (
                    user.email !== "evoker@evoktm.com.br" && (
                      <React.Fragment key={user.codUsuario}>
                        <AdminUser
                          darkMode={darkMode}
                          userId={user.codUsuario || 'N/A'}
                          foto={user.foto || ''}
                          name={user.nome || 'Nome não disponível'}
                          email={user.email || 'Email não disponível'}
                          date={user.data_nasc || 'Data não disponível'}
                          age={user.idade || '---'}
                          phone={user.celular || ''}
                          pay={user.pago}
                          plan={user.plano }
                          price={user.valor || 0}
                          mes={user.mes || 'Mês não disponível'}
                          access={user.relatorioEnviado || false}
                          prompt_tokens={user.prompt_tokens || 0}
                          completion_tokens={user.completion_tokens || 0}
                          sendEmail={sendEmail}
                          blockAccess={blockAccess}
                          getAllUsers={getAllUsers}
                          codRelatorioFinal={user.codRelatorioFinal || ''}
                          relatorioEnviado={user.relatorioEnviado || false}
                        />
                      </React.Fragment>
                    )
                  ))
                )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
